import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Box, Grid, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'
import { handlerErrorV2 } from '../../../../../utils/errors'
import { getSubjects } from '../../../../../services/subjects/subjects.service'
import SelectField from '../../../../FormControl/input/SelectField'
import Skeleton from '@mui/material/Skeleton'

const FormSubject = ({ onChangeAlert }) => {
  const { curriculumId } = useParams()
  const formData = useSelector((state) => state?.dr?.form || {})
  const formError = useSelector((state) => state?.dr?.formError || {})

  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {})
  const [form, setInputForm] = useState(formData)
  const [subjects, setSubjects] = useState([])

  const [isLoading, setIsLoading] = useState(true)
  const [errors, setInputErrors] = useState({})

  const onLoad = useCallback(async () => {
    try {
      let filter = {}
      if (formData?.curriculumElements?.elementId) {
        filter = {
          curriculumelements: {
            elementId: formData?.curriculumElements?.elementId
          }
        }
      }

      if (!isEmpty(filter)) {
        setIsLoading(true)
        const response = await getSubjects(curriculumId, filter)
        if (!response?.data && response?.error) {
          const message = response.error.message || 'An error ocurred'
          setInputErrors({ message })
        } else {
          setSubjects(response.data)
          const find = response.data.find((item) => item._id === form.subjectId)
          if (!find) {
            onChange('subjectId', '')
          }
        }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      setInputErrors({ message })
    } finally {
      setIsLoading(false)
    }
  }, [curriculumId, formData.curriculumElements])

  useEffect(() => {
    onLoad()
  }, [onLoad])
  useEffect(() => {
    setInputErrors(formError)
  }, [formError])

  if (!currentCurriculum || !currentCurriculum?.elements || !currentCurriculum.elementsStructure) return <></>

  const onChange = (name, value) => {
    setInputForm({ ...form, [name]: value })
    setInputErrors({ ...errors, [name]: null })
    onChangeAlert(name, value)
  }

  return (
    <>
      <Box className='px-4 py-2 h-6 bg-primary text-primary-foreground flex items-center'>
        <Typography variant='inherit' className='font-bold capitalize' component='p'>
          Subject
        </Typography>
      </Box>
      <Box className='px-4 py-4'>
        <Grid container spacing={2}>
          <Grid item md={2} sm={3}>
            <Typography
              variant='inherit'
              className='font-bold capitalize'
              color='primary'
              align='right'
              component='p'
            >
              Subject
            </Typography>
          </Grid>
          <Grid item md={9} sm={8}>
            {formData?.linkedClasses?.length > 0 ? (
              <Typography variant='inherit' component='p'>
                {isLoading && <Skeleton variant='text' width={100} />}
                {!isLoading &&
                  subjects
                    ?.filter((item) => form.subjectId.includes(item._id))
                    .map((item) => item.name)
                    .join(', ')}
              </Typography>
            ) : (
              <SelectField
                id='subjectId'
                name='subjectId'
                error={errors.subjectId}
                helperText={errors.subjectId}
                value={form.subjectId || ''}
                onChange={(e) => onChange('subjectId', e.target.value)}
                options={subjects?.map((item) => ({ value: item._id, label: item.name })) || []}
                placeholder='Choose an option'
                loading={isLoading}
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default FormSubject
